import {Injectable} from '@angular/core'
import {HttpClient} from "@angular/common/http"
import {Handicap} from "../../../domain/src/lib/handicap.model"
import {map, Observable} from "rxjs"
import {environment} from "../../../../apps/frontend/src/environments/environment"


@Injectable({
  providedIn: 'root',
})
export class HandicapService {

  constructor(private readonly http: HttpClient) {
  }


  getHandicaps(active?: string): Observable<Handicap[]> {
    const url = `${environment.apiUrl}/handicaps?active=${active}`
    return this.http.get<Handicap[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getHandicapByHandicapId(handicapId: number, active?: string): Observable<Handicap> {
    const url = `${environment.apiUrl}/handicaps/${handicapId}?active=${active}`
    return this.http.get<Handicap>(url).pipe(
        map(values => {
          return values
        }),
    )
  }
}
